import * as React from "react"
import { Redirect, useLocation } from "react-router-dom"

import { accountSettingsPathFromLocation } from "@/constants/accountSettingsSidebar"

/** `/profile` → `/profile/:tab` (preserves non-tab query params, migrates `?tab=`). */
export default function ProfileTabRedirect() {
  const location = useLocation()
  return <Redirect to={accountSettingsPathFromLocation(location.pathname, location.search)} />
}
